import React, { useEffect, useRef, useState } from 'react'
import styles from './companies.module.css'
import {MdModeEditOutline} from 'react-icons/md'

import { useNavigate } from "react-router-dom";
// import cleanerOne from "../../../assets/cleanerOne.png";
// import cleanerTwo from "../../../assets/cleanerTwo.png";
// import plusIcon from "../../../assets/plusIcon.png";
import { List } from "antd";
import { AntdDropdown, SearchInput } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ScheduleMiddleware from '../../store/Middlewares/ScheduleMiddleware';
import moment from 'moment';
import { roles } from '../../config/roles';
import plusImg from '../../assets/plusIcon.png';
import CompanyMiddleware from '../../store/Middlewares/CompanyMiddleware';


const Companies = () => {
    const phoneFormat = (text) => {

        var cleaned = ("" + text).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    
        if (match) {
            var intlCode = match[1] ? "+1 " : "",
              number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
                ""
              );
            return number;
          }
          return text;
      }

    const navigate = useNavigate();
    // const dummyChecklist = [
    //     {
    //         id: 1,
    //         date: "06-29-2023",
    //         customerName: "Mr. James",
    //         cleanerName: "Jason Smith",
    //         category: 'Custodial Engineer',
    //         Time: "10:00 PM-05:00 PM",
    //         Hours: "5 Hr 30 Min",
    //         Location: '8675, New York City'
    //     },
    //     {
    //         id: 2,
    //         date: "06-29-2023",
    //         customerName: "Mr. James",
    //         cleanerName: "Jason Smith",
    //         category: 'Custodial Engineer',
    //         Time: "10:00 PM-05:00 PM",
    //         Hours: "5 Hr 30 Min",
    //         Location: '8675, New York City'
    //     }
    // ];

    useEffect(() => {
        getLanguage();
        getCompaniesData();
    }, []);



    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const user = useSelector(state => state.AuthReducer.user);
    const timeout = useRef(null);
    const [search, setSearch] = useState('');
    const CompanyList = useSelector(
        state => state.CompanyReducer.CompanyList,
    );
    const CompanyListPagination = useSelector(
        state => state.CompanyReducer.CompanyListPagination,
    );
    const role = localStorage.getItem('role')

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    console.log('CompanyList', CompanyList);

    const getCompaniesData = () => {
        let data = {
            next_page_url: undefined,
            search: search
        };
        dispatch(CompanyMiddleware.getCompany(data));
    };


    const onPressLoadMore = () => {
        let data = {
            search: search,
            next_page_url: CompanyListPagination?.links?.next
        };
        dispatch(CompanyMiddleware.getCompany(data));
    };

    const onSearchCompanies = text => {
        let data = {
            search: text,
            next_page_url: undefined
        };
        setSearch(text);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            dispatch(CompanyMiddleware.getCompany(data));
        }, 1000);
    };

    const loadMore =
        CompanyListPagination?.links?.next ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                    display: 'flex', justifyContent: 'center'
                }}
            >
                <button onClick={onPressLoadMore} className={styles.loadMore_button}>
                    Load More
                </button>
            </div>
        ) : null;

    return (
        <div className={styles.createChecklist_mainContainer}>
            <h1 className={styles.heading}>{t("Company")}</h1>
            <div className={styles.filterCont}>
                <div className={styles.filterItem}>
                    <SearchInput onChange={(e) => onSearchCompanies(e.target.value)} placeholder={"Search"} style={{ width: '100%' }} />
                </div>
            </div>
            <List
                grid={{
                    gutter: 16,
                    //   xs: 2,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 2,
                    xxl: 2,
                }}
                // className={styles.createChecklist_list}
                dataSource={CompanyList}
                footer={loadMore}
                style={{ width: '100%' }}
                renderItem={(item) => (
                    <div key={item?.id} className={styles.createChecklist_listItem}>
                        <div className={styles.createChecklist_context}>
                            <div className={styles.createChecklist_heading}>
                                <div>
                                    <h3>{item?.name}</h3>
                                </div>
                                <div style={{cursor:'pointer'}} onClick={()=>navigate('/company/EditCompany',{state:{item}})}>
                                    <MdModeEditOutline size={25} color={'#f6921e'}/>
                                </div>
                            </div>
                            <div className={styles.dataCont} style={{ width: role == roles.customer && '67%' }}>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Address")}</p>
                                    <p className={styles.createChecklist_para}>{item?.address}</p>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Contact Number")}</p>
                                    <p className={styles.createChecklist_para}>{phoneFormat(item?.contact_no)}</p>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Website")}</p>
                                    <p className={styles.createChecklist_para}><a className={styles.createChecklist_para} target="_blank" href={item?.website}>{item?.website?item?.website:<span style={{color:'var(--white-color)'}}>--</span>}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />
            <div className={styles.plusImg}>
                <img onClick={() => navigate("/company/CreateNewCompany")} src={plusImg} />
            </div>
        </div>
    );
};

export default Companies